import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { ResponsiveImage, Modal, ImageCarousel } from '../../components';
import ActionBarMaybe from './ActionBarMaybe';

import css from './ListingPage.module.css';

export const SectionImages = props => {
  const {
    title,
    listing,
    intl,
    isOwnListing,
    editParams,
    handleViewPhotosClick,
    imageCarouselOpen,
    onImageCarouselClose,
    onManageDisableScrolling,
    isPreview,
    isOffer,
    authorBackgroundImg,
  } = props;

  const hasImages = listing?.images && listing.images.length > 0;

  const backgroundImageId = listing?.attributes?.publicData?.backgroundPhotoIds;

  const authorBackgroundImgMaybe = isOffer
    ? authorBackgroundImg
    : null;

  const backgroundImage =
    listing?.images?.find(i => i?.id?.uuid === backgroundImageId) || null;

  const offerBackgroundImage = listing?.images?.filter(i => i?.id?.uuid !== backgroundImageId)?.[0] || authorBackgroundImgMaybe;

  // Action bar is wrapped with a div that prevents the click events
  // to the parent that would otherwise open the image carousel
  const actionBar = title && listing?.id ? (
    <div onClick={e => e.stopPropagation()}>
      <ActionBarMaybe
        isOwnListing={isOwnListing}
        listing={listing}
        editParams={editParams}
        isOffer={isOffer}
      />
    </div>
  ) : null;

  const viewPhotosButton = hasImages ? (
    <button
      className={css.viewPhotos}
      onClick={
        isPreview ? (e) => { e.stopPropagation(), alert(intl.formatMessage({ id: 'PreviewPopup.previewMode' })) }
          : handleViewPhotosClick
      }
    >
      <FormattedMessage
        id="ListingPage.viewImagesButton"
        values={{ count: isOffer ? listing.images.length - 1 : listing.images.length }}
      />
    </button>
  ) : null;

  return (
    <div className={css.sectionImages}>
      <div className={css.threeToTwoWrapper}>
        <div
          className={css.aspectWrapper}
          onClick={
            isPreview ? () => alert(intl.formatMessage({ id: 'PreviewPopup.previewMode' }))
              : handleViewPhotosClick}
        >
          {actionBar}
          <ResponsiveImage
            rootClassName={css.rootForImage}
            alt={title}
            image={isOffer ? offerBackgroundImage : backgroundImage}
            variants={[
              // 'landscape-crop',
              // 'landscape-crop2x',
              // 'landscape-crop4x',
              // 'landscape-crop6x',
              'landscape-crop-custom'
            ]}
          />
          {viewPhotosButton}
        </div>
      </div>
      <Modal
        id="ListingPage.imageCarousel"
        scrollLayerClassName={css.carouselModalScrollLayer}
        containerClassName={css.carouselModalContainer}
        lightCloseButton
        isOpen={imageCarouselOpen}
        onClose={onImageCarouselClose}
        usePortal
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <ImageCarousel
          images={isOffer ? listing?.images?.slice(1) : listing?.images || []}
          imageVariants={['scaled-small', 'scaled-medium', 'scaled-large', 'scaled-xlarge']}
        />
      </Modal>
    </div>
  );
};

export default SectionImages;
